var _defs, _rect, _rect2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#18283b;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(2 2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M125.467,288.781l-2.217,2.9a2.344,2.344,0,0,1-1.861.92h-4.115a.586.586,0,0,1,0-1.172h3.567a1.389,1.389,0,0,0,1.394-1.394,1.367,1.367,0,0,0-1.367-1.341h-4.1a3.393,3.393,0,0,0-4.324-.315l-.441.315v6.641h10.19a3.516,3.516,0,0,0,2.958-1.615l2.287-3.557a1.2,1.2,0,0,0-1.967-1.38Z",
    transform: "translate(-107.625 -276.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M280.948,82.9a.583.583,0,0,0-.207.352.4.4,0,0,0,.1.391c.033.025.069.051.107.075Z",
    transform: "translate(-269.764 -79.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M176.883,9.766A4.883,4.883,0,1,0,172,4.883a4.883,4.883,0,0,0,4.883,4.883ZM175.4,6.479a.391.391,0,0,1,.541-.112,1.187,1.187,0,0,0,.52.223V4.939a2.874,2.874,0,0,1-.589-.344,1.169,1.169,0,0,1-.386-1.152,1.316,1.316,0,0,1,.9-1.031l.073-.021V2.148a.391.391,0,1,1,.781,0v.2a1.356,1.356,0,0,1,.777.4.391.391,0,0,1-.586.516.543.543,0,0,0-.19-.113V4.414l.207.075a1.4,1.4,0,0,1,.95,1.582,1.589,1.589,0,0,1-1.157,1.266v.281a.391.391,0,0,1-.781,0V7.375a1.893,1.893,0,0,1-.948-.355.391.391,0,0,1-.113-.541Z",
    transform: "translate(-165.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M306.7,135.035a.6.6,0,0,0-.386-.695v1.255A.807.807,0,0,0,306.7,135.035Z",
    transform: "translate(-294.345 -129.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.617,282H.586a.586.586,0,0,0-.586.586V290.4a.586.586,0,0,0,.586.586H2.617A.586.586,0,0,0,3.2,290.4v-7.812A.586.586,0,0,0,2.617,282Zm-.968,8.176a.636.636,0,1,1,.45-.186.637.637,0,0,1-.45.186Z",
    transform: "translate(0 -270.984)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingDarkIcon);
export default __webpack_public_path__ + "static/media/pricing-dark-icon.ccf7b9eab3483edafc6a7144f08c66cf.svg";
export { ForwardRef as ReactComponent };